/** Available role mimetypes used when calling api to differentiate data models per role */
export enum RoleMimetype {
  DEFAULT = 'application/json',
  ADMIN = 'application/co.backbone.api.admin.v1+json',
  CREATIVE = 'application/co.backbone.api.creative.v1+json',
  CLIENT = 'application/co.backbone.api.client.v1+json',
  /**
   * v2 role mimetypes — used by the PF v2 (revamp) session-bound endpoints
   * (`POST /workspace/{ws}/sessions`, `GET …/sessions/{id}/products`, …).
   * The same endpoints disambiguate v1 vs v2 by mimetype, so the v2 flow
   * passes these as both `Accept` and `Content-Type` to opt into the v2 model.
   *
   * There are only two: the platform's `Constants.V2` defines client, admin and
   * service, and the PF v2 controllers produce client + admin. A creative v2
   * model was declared here once and had no producer on any endpoint, so every
   * request that asked for it came back 406.
   */
  ADMIN_V2 = 'application/co.backbone.api.admin.v2+json',
  CLIENT_V2 = 'application/co.backbone.api.client.v2+json',
}